var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as focusTrap from 'focus-trap';
var DEFAULT_BOTTOM_SHEET_OPTIONS = {
    disableClosing: false,
};
var BottomSheet = /** @class */ (function () {
    function BottomSheet() {
        this.options = DEFAULT_BOTTOM_SHEET_OPTIONS;
        console.log('BottomSheet');
        this._createBottomSheetHostElements();
        // this.openUrl('/de/ngo/37/projects/public/one-time/253/');
        // this.openUrl('/de/ngo/37/projects/public/one-time/238/');
    }
    BottomSheet.prototype._createBottomSheetHostElements = function () {
        var _this = this;
        this.hostElement = document.createElement('div');
        this.hostElement.classList.add('bottom-sheet');
        this.hostElement.innerHTML = "\n      <div class=\"bottom-sheet__inner\">\n        <button class=\"bottom-sheet__close\" bottomSheetClose>close</button>\n        <div class=\"bottom-sheet__header\">\n        </div>\n        <div class=\"bottom-sheet__content\">\n        </div>\n      </div>\n    ";
        this.contentElement = this.hostElement.querySelector('.bottom-sheet__content');
        this.headerElement = this.hostElement.querySelector('.bottom-sheet__header');
        this.hostElement.addEventListener('click', function (event) {
            if (event.target === _this.hostElement && !_this.options.disableClosing) {
                _this._closeBottomSheet();
            }
        });
        this.focusTrap = focusTrap.createFocusTrap(this.hostElement, {
            onDeactivate: function () {
                _this._focusTrapDeactivated();
            },
            escapeDeactivates: function () {
                return !_this.options.disableClosing;
            },
        });
    };
    BottomSheet.prototype._attachListeners = function () {
        var _this = this;
        var closingElements = document.querySelectorAll('[bottomSheetClose]');
        var _loop_1 = function (idx) {
            var el = closingElements[idx];
            el.addEventListener('click', function (event) {
                event.preventDefault();
                if (el.dataset['close'] === 'reload') {
                    window.location.reload();
                }
                else {
                    _this._closeBottomSheet();
                }
            });
        };
        for (var idx = 0; idx < closingElements.length; idx++) {
            _loop_1(idx);
        }
    };
    BottomSheet.prototype._updateContent = function (content) {
        var _this = this;
        this.contentElement.innerHTML = content;
        this.headerElement.innerHTML = '';
        this.contentElement
            .querySelectorAll('[bottomSheetHeader]')
            .forEach(function (bottomSheetHeader) {
            _this.headerElement.appendChild(bottomSheetHeader);
        });
        requestAnimationFrame(function () {
            var _a;
            _this._attachListeners();
            (_a = _this.focusTrap) === null || _a === void 0 ? void 0 : _a.activate();
        });
    };
    BottomSheet.prototype._openBottomSheet = function () {
        var _this = this;
        if (this.hostElement.parentNode === null) {
            document.body.appendChild(this.hostElement);
        }
        requestAnimationFrame(function () {
            var _a;
            _this.hostElement.classList.add('bottom-sheet--open');
            (_a = _this.focusTrap) === null || _a === void 0 ? void 0 : _a.activate();
        });
    };
    BottomSheet.prototype._closeBottomSheet = function () {
        var _a;
        (_a = this.focusTrap) === null || _a === void 0 ? void 0 : _a.deactivate();
    };
    BottomSheet.prototype._focusTrapDeactivated = function () {
        this.hostElement.classList.remove('bottom-sheet--open');
    };
    BottomSheet.prototype.openUrl = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.options = __assign(__assign({}, DEFAULT_BOTTOM_SHEET_OPTIONS), options);
                        this._updateContent('Loading...');
                        this._openBottomSheet();
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest',
                                    'X-Bottom-Sheet': 'true',
                                },
                            }).then(function (res) { return res.text(); })];
                    case 1:
                        result = _a.sent();
                        this._updateContent(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    return BottomSheet;
}());
export { BottomSheet };
